export enum ReservationOfferSkipIfNumCallsInProgressOptions {
  neverSkip = 'neverSkip',
}
export interface ReservationOfferSkipIfForm {
  skipIfUnavailable: boolean;
  skipIfNumCallsInProgressGE: ReservationOfferSkipIfNumCallsInProgressOptions | number;
}
